/*
 * @Author: Qzx
 * @Date: 2019-06-11 18:58:44
 * @Description: 对Cookie的常规操作
 * @LastEditors: Qzx
 * @LastEditTime: 2019-12-09 11:46:57
 */
/**
 * 获取单个cookie的值
 * @param {string} name
 */
function getCookie(name) {
    let arr;
    let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    arr = document.cookie.match(reg);
    if (arr) {
        return unescape(arr[2]);
    }
    else {
        return '';
    }
}
/**
 * 获取全部cookie对象
 */
function getCookieObj(cookie = document.cookie) {
    let cookieObj = {};
    let cookieSplit = [];
    let cookieArr = cookie.split(';');
    for (const item of cookieArr) {
        if (item) {
            cookieSplit = item.split('=');
            cookieSplit[0] = cookieSplit[0].replace(/(^\s*)|(\s*$)/g, '');
            cookieSplit[1] = cookieSplit[1].replace(/(^\s*)|(\s*$)/g, '');
            cookieObj[cookieSplit[0]] = cookieSplit[1];
        }
    }
    return cookieObj;
}
/**
 * 设置cookie里的值
 * @param {*} name
 * @param {*} value
 */
function setCookie(name, value) {
    let Days = 30;
    let exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie =
        name +
            '=' +
            escape(String(value)) +
            ';domain=.xueersi.com;expires=' +
            exp.toUTCString() +
            ';path=/';
}
/**
 * 删除cookie里的值
 * @param {string} name
 */
function delCookie(name) {
    let exp = new Date();
    exp.setTime(exp.getTime() - 1);
    let cval = getCookie(name);
    if (cval !== null) {
        document.cookie = name + '=' + cval + ';expires=' + exp.toUTCString();
    }
}
var XesCookie = {
    get: getCookie,
    set: setCookie,
    del: delCookie,
    getAll: getCookieObj
};

export default XesCookie;
export { delCookie, getCookie, getCookieObj, setCookie };
